export const AddPropertyInitialValues = {
    property_type_uuid: '',
    property_title: '',
    carpet_area: '',
    carpet_area_unit_uuid: '',
    address_1: '',
    address_2: '',
    country_id: '',
    province_id: '',
    city: '',
    pin_zip: '',
    current_rent: '',
    account_kyc_uuid:'',
    isAgent: '',
    property_usage_type: '',
    owner_name: '',
    owner_email_id: '',
    owner_contact_number: '',
    property_furnishing_status: '',
    sub_unit_available: '',
  }

export const FilterDropdownInitialValues = {
    propertyTitle: '',
    role: '',
    type: '',
  }

